(function () {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // Theme: light default, dark optional
  const THEME_KEY = "savintari_theme";
  const getTheme = () => {
    try {
      const t = localStorage.getItem(THEME_KEY);
      return t === "dark" ? "dark" : "light";
    } catch (_) {
      return "light";
    }
  };
  const applyTheme = (theme) => {
    const next = theme === "dark" ? "dark" : "light";
    document.documentElement.setAttribute("data-theme", next);
    try {
      localStorage.setItem(THEME_KEY, next);
    } catch (_) {}
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) {
      meta.setAttribute(
        "content",
        next === "dark"
          ? meta.getAttribute("data-theme-color-dark") || "#0B0D10"
          : meta.getAttribute("data-theme-color-light") || "#F2F4F7"
      );
    }
    $$("[data-theme-toggle]").forEach((btn) => {
      btn.setAttribute("aria-pressed", next === "dark" ? "true" : "false");
      btn.setAttribute(
        "aria-label",
        next === "dark" ? "Switch to light mode" : "Switch to dark mode"
      );
    });
  };
  applyTheme(getTheme());
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-theme-toggle]");
    if (!btn) return;
    applyTheme(getTheme() === "dark" ? "light" : "dark");
  });

  const menuToggle = $("[data-menu-toggle]");
  const nav = $("[data-nav]");
  if (menuToggle && nav) {
    menuToggle.addEventListener("click", (e) => {
      e.stopPropagation();
      const open = nav.classList.toggle("is-open");
      menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    nav.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        nav.classList.remove("is-open");
        menuToggle.setAttribute("aria-expanded", "false");
      });
    });
    document.addEventListener("click", (e) => {
      if (!nav.classList.contains("is-open")) return;
      if (nav.contains(e.target) || menuToggle.contains(e.target)) return;
      nav.classList.remove("is-open");
      menuToggle.setAttribute("aria-expanded", "false");
    });
  }

  const GEO_LOCALE_KEY = "savintari_geo_locale_v1";
  const MANUAL_LOCALE_KEY = "savintari_manual_locale";

  const COUNTRY_TO_LOCALE = {
    FR: "fr", BE: "fr", LU: "fr", MC: "fr",
    DZ: "fr", MA: "fr", TN: "fr", SN: "fr", CI: "fr", CM: "fr",
    DE: "de", AT: "de", LI: "de",
    ES: "es", AD: "es",
    IT: "it", SM: "it", VA: "it",
    NL: "nl",
    PT: "pt",
    PL: "pl",
    SE: "sv",
    DK: "da",
    NO: "no",
    FI: "fi",
    GR: "el",
    CZ: "cs",
    RO: "ro",
    HU: "hu",
    GB: "en", IE: "en", US: "en", AU: "en", NZ: "en", CA: "en"
  };

  function pickAvailableLocale(preferred, available) {
    if (!preferred || !available.length) return "";
    const exact = available.find((l) => l.toLowerCase() === preferred.toLowerCase());
    if (exact) return exact;
    const base = preferred.split("-")[0].toLowerCase();
    return available.find((l) => l.toLowerCase() === base || l.toLowerCase().startsWith(base + "-")) || "";
  }

  // Disabled: keep Shopify default language (English) unless the visitor
  // chooses another language manually via the localization selector.
  function applyGeoLocale() {
    return;
  }

  $$("[data-localization-select]").forEach((select) => {
    select.addEventListener("change", () => {
      if (select.hasAttribute("data-geo-language") || select.name === "locale_code") {
        localStorage.setItem(MANUAL_LOCALE_KEY, "1");
      }
      const form = select.closest("form");
      if (form) form.submit();
    });
  });

  applyGeoLocale();

  // Product gallery — swipe carousel + pinch / double-tap zoom on the image
  $$("[data-gallery]").forEach((root) => {
    const viewport = root.querySelector("[data-gallery-viewport]");
    const track = root.querySelector("[data-gallery-track]");
    const slides = $$("[data-gallery-slide]", root);
    const thumbs = $$("[data-thumb]", root);
    const dotsWrap = root.querySelector("[data-gallery-dots]");
    const prevBtn = root.querySelector("[data-gallery-prev]");
    const nextBtn = root.querySelector("[data-gallery-next]");
    if (!viewport || !track || !slides.length) return;

    let index = 0;
    let scale = 1;
    let tx = 0;
    let ty = 0;
    let lastTap = 0;

    if (dotsWrap && slides.length > 1) {
      const isEs = (document.documentElement.lang || "").toLowerCase().startsWith("es");
      slides.forEach((_, i) => {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "gallery-dot" + (i === 0 ? " is-active" : "");
        dot.setAttribute("aria-label", (isEs ? "Imagen " : "Image ") + (i + 1));
        dot.addEventListener("click", () => goTo(i));
        dotsWrap.appendChild(dot);
      });
    }
    const dots = dotsWrap ? $$(".gallery-dot", dotsWrap) : [];

    function activeImg() {
      return slides[index]?.querySelector("img") || null;
    }

    function applyZoom(animate) {
      const img = activeImg();
      if (!img) return;
      img.style.transition = animate ? "transform 0.18s ease-out" : "none";
      img.style.transform = "translate3d(" + tx + "px," + ty + "px,0) scale(" + scale + ")";
      viewport.classList.toggle("is-zoomed", scale > 1.05);
    }

    function resetZoom() {
      scale = 1;
      tx = 0;
      ty = 0;
      slides.forEach((slide) => {
        const img = slide.querySelector("img");
        if (!img) return;
        img.style.transition = "transform 0.18s ease-out";
        img.style.transform = "";
      });
      viewport.classList.remove("is-zoomed");
    }

    function syncUI() {
      thumbs.forEach((t, i) => t.classList.toggle("is-active", i === index));
      dots.forEach((d, i) => d.classList.toggle("is-active", i === index));
      slides.forEach((s, i) => s.setAttribute("aria-hidden", i === index ? "false" : "true"));
    }

    function setTrack(offsetPx, animate) {
      track.style.transition = animate === false ? "none" : "";
      track.style.transform = "translate3d(" + offsetPx + "px,0,0)";
    }

    function goTo(i, animate) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      resetZoom();
      setTrack(-index * viewport.clientWidth, animate !== false);
      syncUI();
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        goTo(Number(thumb.getAttribute("data-index") || 0));
      });
    });
    if (prevBtn) prevBtn.addEventListener("click", () => goTo(index - 1));
    if (nextBtn) nextBtn.addEventListener("click", () => goTo(index + 1));

    // —— Swipe between slides (1 finger, not zoomed) ——
    let startX = 0;
    let startY = 0;
    let dragDX = 0;
    let axis = null;
    let dragging = false;

    function onPointerDown(e) {
      if (e.target.closest(".gallery-dot, .gallery-nav")) return;
      if (e.pointerType === "mouse" && e.button !== 0) return;
      if (scale > 1.05) return; // pan handled by touch zoom handlers
      dragging = true;
      axis = null;
      dragDX = 0;
      startX = e.clientX;
      startY = e.clientY;
      setTrack(-index * viewport.clientWidth, false);
    }

    function onPointerMove(e) {
      if (!dragging || scale > 1.05) return;
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      if (!axis) {
        if (Math.abs(dx) < 10 && Math.abs(dy) < 10) return;
        if (Math.abs(dy) > Math.abs(dx)) {
          axis = "y";
          dragging = false;
          setTrack(-index * viewport.clientWidth, true);
          return;
        }
        axis = "x";
        try {
          viewport.setPointerCapture(e.pointerId);
        } catch (err) {}
      }
      if (axis !== "x") return;
      e.preventDefault();
      dragDX = dx;
      setTrack(-index * viewport.clientWidth + dx, false);
    }

    function onPointerUp(e) {
      if (axis === "x") {
        const width = viewport.clientWidth || 1;
        const threshold = Math.min(56, width * 0.18);
        if (dragDX <= -threshold) goTo(index + 1);
        else if (dragDX >= threshold) goTo(index - 1);
        else goTo(index);
        try {
          viewport.releasePointerCapture(e.pointerId);
        } catch (err) {}
      } else if (dragging) {
        setTrack(-index * viewport.clientWidth, true);
      }
      dragging = false;
      axis = null;
      dragDX = 0;
    }

    viewport.addEventListener("pointerdown", onPointerDown);
    viewport.addEventListener("pointermove", onPointerMove, { passive: false });
    viewport.addEventListener("pointerup", onPointerUp);
    viewport.addEventListener("pointercancel", onPointerUp);

    // —— Pinch + pan + double-tap zoom (touch) ——
    let pinchStartDist = 0;
    let pinchStartScale = 1;
    let panStartX = 0;
    let panStartY = 0;
    let panOriginX = 0;
    let panOriginY = 0;
    let pinching = false;

    function touchDist(touches) {
      const dx = touches[0].clientX - touches[1].clientX;
      const dy = touches[0].clientY - touches[1].clientY;
      return Math.hypot(dx, dy) || 1;
    }

    viewport.addEventListener(
      "touchstart",
      (e) => {
        if (e.touches.length === 2) {
          pinching = true;
          dragging = false;
          axis = null;
          pinchStartDist = touchDist(e.touches);
          pinchStartScale = scale;
          e.preventDefault();
          return;
        }
        if (e.touches.length === 1) {
          const t = e.touches[0];
          panStartX = t.clientX;
          panStartY = t.clientY;
          panOriginX = tx;
          panOriginY = ty;

          const now = Date.now();
          if (now - lastTap < 280) {
            // Double-tap zoom toggle
            if (scale > 1.1) {
              resetZoom();
            } else {
              const rect = viewport.getBoundingClientRect();
              const cx = t.clientX - rect.left - rect.width / 2;
              const cy = t.clientY - rect.top - rect.height / 2;
              scale = 2.5;
              tx = -cx * 0.6;
              ty = -cy * 0.6;
              applyZoom(true);
            }
            lastTap = 0;
            e.preventDefault();
          } else {
            lastTap = now;
          }
        }
      },
      { passive: false }
    );

    viewport.addEventListener(
      "touchmove",
      (e) => {
        if (e.touches.length === 2) {
          pinching = true;
          dragging = false;
          const dist = touchDist(e.touches);
          scale = Math.min(4, Math.max(1, pinchStartScale * (dist / pinchStartDist)));
          if (scale <= 1.02) {
            scale = 1;
            tx = 0;
            ty = 0;
          }
          applyZoom(false);
          e.preventDefault();
          return;
        }
        if (e.touches.length === 1 && scale > 1.05) {
          const t = e.touches[0];
          tx = panOriginX + (t.clientX - panStartX);
          ty = panOriginY + (t.clientY - panStartY);
          applyZoom(false);
          e.preventDefault();
        }
      },
      { passive: false }
    );

    viewport.addEventListener(
      "touchend",
      (e) => {
        if (pinching && e.touches.length < 2) {
          pinching = false;
          if (scale < 1.08) resetZoom();
          else applyZoom(true);
        }
      },
      { passive: true }
    );

    viewport.addEventListener(
      "dragstart",
      (e) => {
        e.preventDefault();
      },
      true
    );

    window.addEventListener(
      "resize",
      () => {
        goTo(index, false);
      },
      { passive: true }
    );

    root._goTo = goTo;
    goTo(0, false);
  });

  function fileKey(url) {
    return String(url || "")
      .split("?")[0]
      .split("/")
      .pop()
      .replace(/_\d+x\d*/g, "")
      .replace(/\.[a-z0-9]+$/i, "")
      .toLowerCase();
  }

  function normColor(s) {
    return String(s || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "");
  }

  function loadColorImageMap() {
    const el = $("[data-color-image-map]");
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || "{}") || {};
    } catch (_) {
      return {};
    }
  }

  const colorImageMap = loadColorImageMap();

  function showProductColor(color) {
    if (!color) return;
    const gallery = $("[data-gallery]");
    if (!gallery) return;
    const slides = $$("[data-gallery-slide]", gallery);
    const keys = Object.keys(colorImageMap);
    const mappedKey = keys.find((k) => k === color || normColor(k) === normColor(color));
    const info = mappedKey ? colorImageMap[mappedKey] : null;
    let wantSrc = info && info.src;
    if (!wantSrc) {
      $$("[data-simple-variant-map], [data-variant-map]").some((el) => {
        try {
          const variants = JSON.parse(el.textContent || "[]");
          const hit = variants.find((v) => (v.options || []).includes(color) && v.image);
          if (hit) {
            wantSrc = hit.image;
            return true;
          }
        } catch (_) {}
        return false;
      });
    }
    const wantKey = fileKey(wantSrc);
    let idx = -1;
    if (wantKey) {
      idx = slides.findIndex((s) => {
        const src = s.getAttribute("data-image-src") || s.querySelector("img")?.src || "";
        return fileKey(src) === wantKey;
      });
    }
    if (idx < 0) {
      const n = normColor(color);
      if (n.length >= 3) {
        idx = slides.findIndex((s) => {
          const img = s.querySelector("img");
          const hay = normColor((img && img.alt) || "") + normColor(s.getAttribute("data-image-src") || "");
          return hay.includes(n);
        });
      }
    }
    if (idx >= 0 && typeof gallery._goTo === "function") {
      gallery._goTo(idx);
      return;
    }
    if (wantSrc) {
      const slide = slides[0];
      const img = slide && slide.querySelector("img");
      if (img) {
        img.src = wantSrc;
        slide.setAttribute("data-image-src", wantSrc);
        if (typeof gallery._goTo === "function") gallery._goTo(0);
      }
    }
  }

  // Remove leftover lightbox from previous version if still in DOM
  document.querySelector("[data-zoom-lightbox]")?.remove();
  document.documentElement.classList.remove("zoom-open");

  const bundles = $$("[data-bundle]");
  const qtyInput = $("[data-bundle-qty]");
  const priceCurrent = $("[data-price-current]");
  const priceCompare = $("[data-price-compare]");
  const saveLabel = $("[data-save-label]");
  const stickyPrice = $("[data-sticky-price]");
  const variantInput = $("#VariantSelector");
  const variantMapEl = $("[data-variant-map]");
  const shirtSlots = $$("[data-shirt-slot]");
  const slotsRoot = $("[data-shirt-slots]");
  const slotsHint = $("[data-slots-hint]");
  const slotsTitle = $("[data-slots-title]");
  const isSeat = document.documentElement.getAttribute("data-pdp") === "product-seat";
  let selectedOffer = "";
  let variantMap = [];

  if (variantMapEl) {
    try {
      variantMap = JSON.parse(variantMapEl.textContent || "[]");
    } catch (e) {
      variantMap = [];
    }
  }

  function slotColor(i) {
    const el = document.querySelector(`[data-slot-color="${i}"]`);
    return el ? el.value : "";
  }

  function slotSize(i) {
    const el = document.querySelector(`[data-slot-size="${i}"]`);
    return el ? el.value : "";
  }

  function updateSlotProperties(pieces) {
    shirtSlots.forEach((slot) => {
      const i = Number(slot.getAttribute("data-shirt-slot") || 0);
      const prop = slot.querySelector("[data-slot-property]");
      const active = i >= 1 && i <= pieces;
      slot.hidden = !active;
      slot.classList.toggle("is-hidden", !active);
      if (!prop) return;
      if (active) {
        const record = !isSeat || pieces > 1;
        prop.disabled = !record;
        prop.value = record ? (isSeat ? slotColor(i) : `${slotColor(i)} / ${slotSize(i)}`) : "";
      } else {
        prop.disabled = true;
        prop.value = "";
      }
      if (isSeat) {
        const label = slot.querySelector("[data-seat-slot-label]");
        if (label) label.textContent = `Cover ${i}`;
      }
    });
    if (isSeat && slotsRoot) slotsRoot.classList.toggle("is-single", pieces < 2);
    if (slotsTitle) {
      slotsTitle.textContent = isSeat
        ? pieces > 1
          ? "Choose a colour for each cover"
          : "Colour"
        : pieces > 1
          ? `Configure each of your ${pieces} tanks`
          : "Configure your tank";
    }
    if (slotsHint) {
      slotsHint.textContent = isSeat
        ? pieces > 1
          ? "Each cover can be a different colour."
          : "Pick a colour for this cover."
        : pieces > 1
          ? `Pick a different color & size for Tank 1 through Tank ${pieces}.`
          : "Pick color & size for your tank.";
    }
  }

  function syncOfferVariant(offerOverride) {
    if (!variantMap.length || !variantInput || !variantInput.hasAttribute("data-offer-variant")) return;
    const offer = offerOverride || selectedOffer;
    if (!offer) return;
    const pill = document.querySelector(
      '[data-option-swatches="Color"] .size-pill.is-selected, [data-option-swatches="Colour"] .size-pill.is-selected'
    );
    const pillColor = pill ? pill.getAttribute("data-option-value") || "" : "";
    const color = slotColor(1) || pillColor;
    const size = slotSize(1);
    const optionCount = (variantMap[0].options || []).length;
    const selected = new Array(optionCount).fill(null);
    const offerNames = new Set(
      bundles.map((b) => b.getAttribute("data-offer")).filter(Boolean)
    );
    const colors = new Set(
      [...document.querySelectorAll("[data-slot-color='1'] option")].map((o) => o.value)
    );
    if (!colors.size) {
      document
        .querySelectorAll(
          '[data-option-swatches="Color"] .size-pill, [data-option-swatches="Colour"] .size-pill, [data-seat-color="1"] .size-pill'
        )
        .forEach((btn) => {
          const value = btn.getAttribute("data-option-value");
          if (value) colors.add(value);
        });
    }
    const sizes = new Set(
      [...document.querySelectorAll("[data-slot-size='1'] option")].map((o) => o.value)
    );
    let offerIdx = -1;
    let colorIdx = -1;
    let sizeIdx = -1;
    (variantMap[0].options || []).forEach((val, idx) => {
      if (offerNames.has(val)) offerIdx = idx;
      else if (colors.has(val)) colorIdx = idx;
      else if (sizes.has(val)) sizeIdx = idx;
    });
    // Scan all variants if first row ambiguous
    if (offerIdx < 0 || (colors.size && colorIdx < 0) || (sizes.size && sizeIdx < 0)) {
      for (let i = 0; i < optionCount; i++) {
        const vals = new Set(variantMap.map((v) => (v.options || [])[i]));
        if (offerIdx < 0 && [...offerNames].every((n) => vals.has(n) || n === "")) offerIdx = i;
        if (offerIdx < 0 && [...offerNames].some((n) => vals.has(n))) offerIdx = i;
        if (colorIdx < 0 && colors.size && [...colors].every((c) => vals.has(c))) colorIdx = i;
        if (sizeIdx < 0 && sizes.size && [...sizes].every((s) => vals.has(s))) sizeIdx = i;
      }
    }
    // Offer-only products (no color/size): match by offer value alone
    if (optionCount === 1 || (offerIdx >= 0 && colorIdx < 0 && sizeIdx < 0 && !colors.size && !sizes.size)) {
      const matchOffer = variantMap.find((v) => (v.options || []).includes(offer));
      if (matchOffer) {
        variantInput.value = String(matchOffer.id);
        return;
      }
    }
    if (offerIdx < 0) offerIdx = 0;
    selected[offerIdx] = offer;
    if (colorIdx >= 0) selected[colorIdx] = color;
    if (sizeIdx >= 0) selected[sizeIdx] = size;

    const match = variantMap.find((v) => {
      const opts = v.options || [];
      if (opts.length !== selected.length) return false;
      return opts.every((o, i) => o === selected[i]);
    });
    if (match) variantInput.value = String(match.id);
  }

  function plainMoney(value) {
    if (!value) return "";
    const raw = String(value);
    if (!/[<>]/.test(raw)) return raw.trim();
    const box = document.createElement("div");
    box.innerHTML = raw;
    return (box.textContent || box.innerText || "").trim();
  }

  function selectBundle(el) {
    bundles.forEach((b) => b.classList.remove("is-selected"));
    el.classList.add("is-selected");
    const offer = el.getAttribute("data-offer") || "";
    selectedOffer = offer;
    if (qtyInput) qtyInput.value = el.getAttribute("data-qty") || "1";
    const pieces = Math.max(1, Math.min(4, Number(el.getAttribute("data-pieces") || 1)));
    updateSlotProperties(pieces);
    if (slotsRoot && pieces > 1 && document.querySelector("[data-slot-color], [data-slot-size]")) {
      slotsRoot.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
    const price = plainMoney(el.getAttribute("data-price") || "");
    const compare = plainMoney(el.getAttribute("data-compare") || "");
    const save = plainMoney(el.getAttribute("data-save") || "");
    if (priceCurrent) priceCurrent.textContent = price;
    if (priceCompare) {
      priceCompare.textContent = compare;
      priceCompare.style.display = compare ? "" : "none";
    }
    if (saveLabel) {
      saveLabel.textContent = save;
      saveLabel.style.display = save ? "" : "none";
    }
    if (stickyPrice) stickyPrice.textContent = price;
    if (offer) syncOfferVariant(offer);
  }

  bundles.forEach((bundle) => {
    bundle.addEventListener("click", () => selectBundle(bundle));
  });

  document.querySelectorAll("[data-seat-color]").forEach((row) => {
    row.querySelectorAll(".size-pill").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        row.querySelectorAll(".size-pill").forEach((other) => {
          other.classList.remove("is-selected");
          other.setAttribute("aria-selected", "false");
        });
        btn.classList.add("is-selected");
        btn.setAttribute("aria-selected", "true");
        const value = btn.getAttribute("data-option-value") || "";
        const slot = row.closest("[data-shirt-slot]");
        const index = slot ? slot.getAttribute("data-shirt-slot") : "";
        const hidden = document.querySelector(`[data-slot-color="${index}"]`);
        if (hidden) hidden.value = value;
        showProductColor(value);
        const active = $(".bundle.is-selected");
        const pieces = Math.max(
          1,
          Math.min(4, Number((active && active.getAttribute("data-pieces")) || 1))
        );
        updateSlotProperties(pieces);
        if (active) syncOfferVariant(active.getAttribute("data-offer") || "");
      });
    });
  });

  $$('[data-option-swatches="Color"], [data-option-swatches="Colour"]').forEach((row) => {
    if (row.closest("[data-pairs-slots], [data-shirt-slots]")) return;
    if (!$("[data-offer-variant]")) return;
    row.querySelectorAll(".size-pill").forEach((btn) => {
      btn.addEventListener("click", () => {
        row.querySelectorAll(".size-pill").forEach((other) => {
          other.classList.remove("is-selected");
          other.setAttribute("aria-selected", "false");
        });
        btn.classList.add("is-selected");
        btn.setAttribute("aria-selected", "true");
        const label = row.querySelector("[data-swatch-label]");
        const value = btn.getAttribute("data-option-value") || "";
        if (label) label.textContent = value;
        showProductColor(value);
        const active = $(".bundle.is-selected");
        if (active) syncOfferVariant(active.getAttribute("data-offer") || "");
      });
    });
  });

  document.querySelectorAll("[data-slot-color], [data-slot-size]").forEach((sel) => {
    sel.addEventListener("change", () => {
      const active = $(".bundle.is-selected");
      const pieces = Math.max(
        1,
        Math.min(4, Number((active && active.getAttribute("data-pieces")) || 1))
      );
      updateSlotProperties(pieces);
      const offer = (active && active.getAttribute("data-offer")) || selectedOffer;
      syncOfferVariant(offer);
      if (sel.hasAttribute("data-slot-color")) showProductColor(sel.value);
    });
  });

  const selected = $(".bundle.is-selected");
  if (selected) selectBundle(selected);
  else if (shirtSlots.length) updateSlotProperties(1);

  const sticky = $("[data-sticky-atc]");
  const trigger = $("[data-atc-trigger]");
  if (sticky && trigger && "IntersectionObserver" in window) {
    let atcOffscreen = false;
    function syncStickyAtc() {
      // Don't cover the first viewport — only after the customer starts scrolling
      sticky.classList.toggle("is-visible", atcOffscreen && window.scrollY > 56);
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        atcOffscreen = !entry.isIntersecting;
        syncStickyAtc();
      },
      { threshold: 0.15 }
    );
    observer.observe(trigger);
    window.addEventListener("scroll", syncStickyAtc, { passive: true });
    syncStickyAtc();
  }

  const stickyBtn = $("[data-sticky-submit]");
  const form = $("[data-product-form]");
  if (stickyBtn && form) {
    stickyBtn.addEventListener("click", () => {
      const sizeRow = document.querySelector('[data-option-swatches="Size"]');
      if (sizeRow) {
        const rect = sizeRow.getBoundingClientRect();
        const offscreen = rect.bottom < 80 || rect.top > window.innerHeight - 80;
        if (offscreen) {
          sizeRow.classList.add("is-attention");
          sizeRow.scrollIntoView({ behavior: "smooth", block: "center" });
          setTimeout(() => sizeRow.classList.remove("is-attention"), 1600);
          setTimeout(() => {
            if (typeof form.requestSubmit === "function") form.requestSubmit();
            else form.submit();
          }, 500);
          return;
        }
      }
      if (typeof form.requestSubmit === "function") form.requestSubmit();
      else form.submit();
    });
  }

  if (form && window.fbq) {
    form.addEventListener("submit", () => {
      try {
        const qty = parseInt(($("[data-bundle-qty]") || {}).value || "1", 10) || 1;
        const priceEl = $("[data-price-current]");
        const priceText = priceEl ? priceEl.textContent.replace(/[^\d.,]/g, "").replace(",", ".") : "";
        const value = parseFloat(priceText) || 0;
        const variantInput = form.querySelector('[name="id"]');
        fbq("track", "AddToCart", {
          content_ids: variantInput && variantInput.value ? [String(variantInput.value)] : [],
          content_type: "product",
          num_items: qty,
          value: value,
          currency: (window.SAVINTARI_PIXEL && window.SAVINTARI_PIXEL.currency) || "GBP"
        });
      } catch (e) {}
    });
  }

  // Dynamic stock counter
  const stockText = $(".stock-line strong");
  if (stockText) {
    const baseStock = parseInt(stockText.textContent.match(/\d+/)) || 41;
    const stockVariations = [
      baseStock,
      baseStock - 1,
      baseStock - 2,
      baseStock - 3,
      baseStock + 1
    ];
    let currentIndex = 0;
    
    setInterval(() => {
      currentIndex = (currentIndex + 1) % stockVariations.length;
      const newStock = stockVariations[currentIndex];
      stockText.textContent = stockText.textContent.replace(/\d+/, newStock);
    }, 8000);
  }

  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  // Sticky header elevation
  const siteHeader = $(".site-header");
  if (siteHeader) {
    const syncHeader = () => {
      siteHeader.classList.toggle("is-scrolled", window.scrollY > 12);
    };
    syncHeader();
    window.addEventListener("scroll", syncHeader, { passive: true });
  }

  // Soft hero parallax
  const heroMedia = $(".hero-media");
  if (heroMedia && !reduceMotion) {
    const syncHero = () => {
      const y = Math.min(window.scrollY, 420);
      heroMedia.style.transform = `translate3d(0, ${y * 0.2}px, 0)`;
    };
    syncHero();
    window.addEventListener("scroll", syncHero, { passive: true });
  }

  $$(".js-reveal").forEach((el) => el.classList.add("is-in"));

  // Product carousel — drag / swipe + arrows
  $$("[data-carousel]").forEach((carousel) => {
    const track = carousel.querySelector("[data-carousel-track]");
    if (!track) return;

    const section = carousel.closest(".section") || carousel.parentElement;
    const prevBtn = section && section.querySelector("[data-carousel-prev]");
    const nextBtn = section && section.querySelector("[data-carousel-next]");

    const slideStep = () => {
      const slide = track.querySelector(".product-carousel__slide");
      if (!slide) return 220;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || "16") || 16;
      return slide.getBoundingClientRect().width + gap;
    };

    if (prevBtn) {
      prevBtn.addEventListener("click", () => {
        track.scrollBy({ left: -slideStep(), behavior: "smooth" });
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener("click", () => {
        track.scrollBy({ left: slideStep(), behavior: "smooth" });
      });
    }

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let moved = false;

    const onDown = (clientX) => {
      isDown = true;
      moved = false;
      startX = clientX;
      scrollLeft = track.scrollLeft;
      track.classList.add("is-dragging");
    };

    const onMove = (clientX) => {
      if (!isDown) return;
      const walk = clientX - startX;
      if (Math.abs(walk) > 4) moved = true;
      track.scrollLeft = scrollLeft - walk;
    };

    const onUp = () => {
      if (!isDown) return;
      isDown = false;
      track.classList.remove("is-dragging");
    };

    track.addEventListener("mousedown", (e) => {
      if (e.button !== 0) return;
      e.preventDefault();
      onDown(e.clientX);
    });
    window.addEventListener("mousemove", (e) => onMove(e.clientX));
    window.addEventListener("mouseup", onUp);

    track.addEventListener(
      "click",
      (e) => {
        if (moved) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );

    track.addEventListener(
      "dragstart",
      (e) => {
        e.preventDefault();
      },
      true
    );
  });

  // Trustpilot floating reviews slider
  $$("[data-tp-slider]").forEach((root, rootIndex) => {
    // Keep only one floating widget if duplicates exist
    if (rootIndex > 0) {
      const section = root.closest(".shopify-section");
      if (section) section.remove();
      else root.remove();
      return;
    }

    const track = root.querySelector("[data-tp-track]");
    const slides = $$("[data-tp-slide]", root);
    const dotsWrap = root.querySelector("[data-tp-dots]");
    const prevBtn = root.querySelector("[data-tp-prev]");
    const nextBtn = root.querySelector("[data-tp-next]");
    const toggle = root.querySelector("[data-tp-toggle]");
    const closeBtn = root.querySelector("[data-tp-close]");

    let index = 0;
    let timer = null;
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function setOpen(open) {
      root.classList.toggle("is-open", open);
      if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) restart();
      else clearInterval(timer);
    }

    // Always wire open/close — even when review blocks are empty
    if (toggle) {
      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(!root.classList.contains("is-open"));
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(false);
      });
    }
    document.addEventListener("click", (e) => {
      if (!root.classList.contains("is-open")) return;
      if (root.contains(e.target)) return;
      setOpen(false);
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") setOpen(false);
    });

    if (!track || !slides.length) return;

    if (slides.length > 1 && dotsWrap) {
      slides.forEach((_, i) => {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "tp-slider__dot";
        dot.setAttribute("role", "tab");
        dot.setAttribute("aria-label", (document.documentElement.lang || "").toLowerCase().startsWith("es") ? ("Opinión " + (i + 1)) : ("Review " + (i + 1)));
        dot.addEventListener("click", () => goTo(i, true));
        dotsWrap.appendChild(dot);
      });
    }

    const dots = dotsWrap ? $$(".tp-slider__dot", dotsWrap) : [];

    function goTo(i, user) {
      index = (i + slides.length) % slides.length;
      track.style.transform = "translate3d(" + -index * 100 + "%,0,0)";
      slides.forEach((slide, s) => {
        slide.setAttribute("aria-hidden", s === index ? "false" : "true");
      });
      dots.forEach((dot, d) => {
        dot.classList.toggle("is-active", d === index);
        dot.setAttribute("aria-selected", d === index ? "true" : "false");
      });
      if (user && root.classList.contains("is-open")) restart();
    }

    function next() {
      if (!root.classList.contains("is-open")) return;
      goTo(index + 1, false);
    }

    function restart() {
      if (reduceMotion || slides.length < 2) return;
      clearInterval(timer);
      timer = setInterval(next, 4500);
    }

    if (prevBtn) prevBtn.addEventListener("click", () => goTo(index - 1, true));
    if (nextBtn) nextBtn.addEventListener("click", () => goTo(index + 1, true));

    root.addEventListener("mouseenter", () => clearInterval(timer));
    root.addEventListener("mouseleave", () => {
      if (root.classList.contains("is-open")) restart();
    });

    let touchX = 0;
    track.addEventListener(
      "touchstart",
      (e) => {
        touchX = e.changedTouches[0].clientX;
      },
      { passive: true }
    );
    track.addEventListener(
      "touchend",
      (e) => {
        const dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) < 40) return;
        if (dx < 0) goTo(index + 1, true);
        else goTo(index - 1, true);
      },
      { passive: true }
    );

    goTo(0, false);
  });

  // Simple apparel size/color pills → variant id
  (function initSimpleSwatches() {
    const mapEl = $("[data-simple-variant-map]");
    const input = $("[data-simple-variant]");
    if (!mapEl || !input) return;
    let variants = [];
    try {
      variants = JSON.parse(mapEl.textContent || "[]");
    } catch (_) {
      return;
    }
    const rows = $$("[data-option-swatches]");
    const selected = {};
    function moneyLike(cents) {
      const sample = ($(".price--top .price__current") || {}).textContent || "£0.00";
      const symbol = (String(sample).match(/^[^\d-]+/) || ["£"])[0];
      return symbol + (Number(cents) / 100).toFixed(2);
    }
    function findMatch(choice) {
      return variants.find((v) => {
        const opts = v.options || [];
        return Object.keys(choice).every((k) => opts[Number(k)] === choice[k]);
      });
    }
    function isColorRow(row) {
      return /^colou?r$/i.test(row.getAttribute("data-option-swatches") || "");
    }
    function markMissing() {
      rows.forEach((row) => {
        const pos = Number(row.getAttribute("data-option-position") || "1") - 1;
        const colorRow = isColorRow(row);
        row.querySelectorAll(".size-pill").forEach((pill) => {
          if (colorRow) {
            pill.classList.remove("is-unavailable");
            pill.disabled = false;
            return;
          }
          const trial = Object.assign({}, selected, { [pos]: pill.getAttribute("data-option-value") });
          const ok = !!findMatch(trial);
          pill.classList.toggle("is-unavailable", !ok);
          pill.disabled = !ok;
        });
      });
    }
    function showMatch(match) {
      if (!match) return;
      input.value = match.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
      const top = $(".price--top");
      if (top && match.price) {
        const cur = top.querySelector(".price__current");
        const cmp = top.querySelector(".price__compare");
        const sav = top.querySelector(".price__savings");
        if (cur) cur.textContent = moneyLike(match.price);
        if (cmp) {
          const show = match.compare && Number(match.compare) > Number(match.price);
          cmp.hidden = !show;
          if (show) cmp.textContent = moneyLike(match.compare);
        }
        if (sav) {
          const show = match.compare && Number(match.compare) > Number(match.price);
          sav.hidden = !show;
          if (show) {
            const pct = Math.floor(((Number(match.compare) - Number(match.price)) * 100) / Number(match.compare));
            sav.textContent = pct + "% Savings";
          }
        }
      }
      const sticky = $("[data-sticky-price]");
      if (sticky && match.price) sticky.textContent = moneyLike(match.price);
    }
    rows.forEach((row) => {
      const pos = Number(row.getAttribute("data-option-position") || "1") - 1;
      const active = row.querySelector(".size-pill.is-selected");
      if (active) selected[pos] = active.getAttribute("data-option-value");
      row.querySelectorAll(".size-pill").forEach((btn) => {
        btn.addEventListener("click", () => {
          if (btn.classList.contains("is-unavailable")) return;
          const colorRow = isColorRow(row);
          const value = btn.getAttribute("data-option-value");
          let match = findMatch(Object.assign({}, selected, { [pos]: value }));
          if (!match && colorRow) {
            match = variants.find((v) => (v.options || [])[pos] === value);
          }
          if (!match) return;
          rows.forEach((r) => {
            const p = Number(r.getAttribute("data-option-position") || "1") - 1;
            const val = (match.options || [])[p];
            selected[p] = val;
            r.querySelectorAll(".size-pill").forEach((b) => {
              const on = b.getAttribute("data-option-value") === val;
              b.classList.toggle("is-selected", on);
              b.setAttribute("aria-selected", on ? "true" : "false");
            });
            const label = r.querySelector("[data-swatch-label]");
            if (label) label.textContent = val;
          });
          showMatch(match);
          markMissing();
          if (colorRow) showProductColor(value || "");
        });
      });
    });
    markMissing();
  })();

  (function initPairsOffer() {
    const root = $("[data-pairs-offer]");
    const form = $("[data-product-form]");
    if (!root || !form) return;

    const mapEl = $("[data-simple-variant-map]");
    const input = $("[data-simple-variant]");
    const cfgEl = $("[data-pairs-config]");
    const cards = $$("[data-pairs-card]", root);
    const slots = $$("[data-pair-slot]");
    const slotsRoot = $("[data-pairs-slots]");
    const slotsTitle = $("[data-pairs-slots-title]");
    const slotsHint = $("[data-pairs-slots-hint]");
    const topPrice = $("[data-pairs-top-price]");
    const errorEl = $("[data-pairs-error]");
    let variants = [];
    let cfg = {
      pct2: 0.1,
      pct3: 0.14,
      moneyFormat: "£{{amount}}",
      noun: "pair",
      nounPlural: "pairs",
      nounCap: "Pair",
      eachLabel: "a pair",
      oneLabel: "This pair",
      hintOne: "Pick the colour and EU size for this pair.",
      hintMulti: "Each pair can be a different colour or size.",
      error: "Please choose an available colour and size for each pair.",
    };
    try {
      variants = JSON.parse((mapEl && mapEl.textContent) || "[]");
    } catch (_) {}
    try {
      if (cfgEl) cfg = Object.assign(cfg, JSON.parse(cfgEl.textContent || "{}"));
    } catch (_) {}

    const cartRoot = () =>
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

    function formatMoney(cents) {
      const format = cfg.moneyFormat || "£{{amount}}";
      const amount = (Math.round(cents) / 100).toFixed(2);
      const withComma = amount.replace(/\d(?=(\d{3})+\.)/g, "$&,");
      const noDec = String(Math.round(cents / 100));
      return String(format)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace(".", ","))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
        .replace(/\{\{\s*amount\s*\}\}/g, withComma)
        .replace(/<[^>]+>/g, "")
        .trim();
    }

    function selectedValue(scope, name) {
      const row = scope.querySelector(`[data-option-swatches="${name}"], [data-pair-swatches="${name}"]`);
      if (!row) return "";
      const active = row.querySelector(".size-pill.is-selected");
      return active ? active.getAttribute("data-option-value") || "" : "";
    }

    function pairSelection(index) {
      const scope = $(`[data-pair-slot="${index}"]`) || form;
      const color = selectedValue(scope, "Color") || selectedValue(scope, "Colour");
      const size = selectedValue(scope, "Size");
      return { color, size };
    }

    function findVariant(sel) {
      return variants.find((v) => {
        const opts = v.options || [];
        const colorOk = !sel.color || opts.includes(sel.color);
        const sizeOk = !sel.size || opts.includes(sel.size);
        return colorOk && sizeOk;
      });
    }

    function unitCents() {
      const id = input ? Number(input.value) : 0;
      const match = variants.find((v) => Number(v.id) === id) || variants[0];
      return match && match.price ? Number(match.price) : 0;
    }

    function currentPieces() {
      const active = root.querySelector("[data-pairs-card].is-selected");
      return Math.max(1, Math.min(3, Number((active && active.getAttribute("data-pieces")) || 1)));
    }

    function updatePrices() {
      const unit = unitCents();
      cards.forEach((card) => {
        const pieces = Number(card.getAttribute("data-pieces") || 1);
        const pct = Number(card.getAttribute("data-pct") || 0);
        const compare = unit * pieces;
        const price = Math.round(compare * (1 - pct));
        const priceEl = card.querySelector("[data-pairs-card-price]");
        const compareEl = card.querySelector("[data-pairs-card-compare]");
        const eachEl = card.querySelector("[data-pairs-card-each]");
        if (priceEl) priceEl.textContent = formatMoney(price);
        if (compareEl) {
          compareEl.textContent = formatMoney(compare);
          compareEl.hidden = pieces === 1 || price >= compare;
        }
        if (eachEl && pieces > 1) {
          const each = Math.round(price / pieces);
          const off = Math.round(pct * 100);
          eachEl.textContent = `${formatMoney(each)} ${cfg.eachLabel} · ${off}% off`;
        }
        if (card.classList.contains("is-selected") && topPrice) {
          topPrice.textContent = formatMoney(price);
        }
        const stickyPrice = $("[data-sticky-price]");
        if (card.classList.contains("is-selected") && stickyPrice) {
          stickyPrice.textContent = formatMoney(price);
        }
      });
    }

    function setPieces(pieces) {
      cards.forEach((card) => {
        const on = Number(card.getAttribute("data-pieces")) === pieces;
        card.classList.toggle("is-selected", on);
        card.setAttribute("aria-checked", on ? "true" : "false");
      });
      slots.forEach((slot) => {
        const i = Number(slot.getAttribute("data-pair-slot") || 0);
        const on = i >= 1 && i <= pieces;
        slot.hidden = !on;
        slot.classList.toggle("is-hidden", !on);
        const heading = slot.querySelector("[data-pair-heading]");
        if (heading) {
          heading.textContent = pieces > 1 ? cfg.nounCap + " " + i : cfg.oneLabel;
        }
      });
      if (slotsRoot) slotsRoot.classList.toggle("is-multi", pieces > 1);
      if (slotsTitle) {
        slotsTitle.textContent =
          pieces > 1 ? "Colour & size for each " + cfg.noun : "Colour & size";
      }
      if (slotsHint) {
        slotsHint.textContent = pieces > 1 ? cfg.hintMulti : cfg.hintOne;
      }
      const wallets = $("[data-pdp-wallets]");
      if (wallets) wallets.hidden = pieces > 1;
      updatePrices();
      if (pieces > 1) {
        const next = $('[data-pair-slot="2"]');
        if (next) next.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }

    cards.forEach((card) => {
      card.setAttribute("role", "radio");
      card.setAttribute("tabindex", "0");
      card.setAttribute(
        "aria-checked",
        card.classList.contains("is-selected") ? "true" : "false"
      );
      const pick = () => setPieces(Number(card.getAttribute("data-pieces") || 1));
      card.addEventListener("click", pick);
      card.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          pick();
        }
      });
    });

    $$("[data-pair-swatches]").forEach((row) => {
      row.querySelectorAll(".size-pill").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          row.querySelectorAll(".size-pill").forEach((b) => {
            b.classList.remove("is-selected");
            b.setAttribute("aria-selected", "false");
          });
          btn.classList.add("is-selected");
          btn.setAttribute("aria-selected", "true");
          const label = row.querySelector("[data-pair-label], [data-swatch-label]");
          if (label) label.textContent = btn.getAttribute("data-option-value") || "";
          const swatchName = row.getAttribute("data-pair-swatches") || "";
          if (/^colou?r$/i.test(swatchName)) {
            showProductColor(btn.getAttribute("data-option-value") || "");
          }
        });
      });
    });

    if (input) input.addEventListener("change", updatePrices);
    setPieces(1);

    function showError(msg) {
      if (!errorEl) return;
      errorEl.hidden = !msg;
      errorEl.textContent = msg || "";
    }

    form.addEventListener("submit", async (e) => {
      const pieces = currentPieces();
      if (pieces < 2) return;
      e.preventDefault();
      showError("");
      const grouped = new Map();
      for (let i = 1; i <= pieces; i++) {
        const match = findVariant(pairSelection(i));
        if (!match || !match.available) {
          showError(cfg.error || "Please choose an available colour and size for each item.");
          return;
        }
        const id = Number(match.id);
        grouped.set(id, (grouped.get(id) || 0) + 1);
      }
      const items = [...grouped.entries()].map(([id, quantity]) => ({ id, quantity }));
      const btn = form.querySelector("[data-atc-trigger]");
      if (btn) btn.disabled = true;
      try {
        const res = await fetch(cartRoot() + "cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || "Could not add to bag");
        }
        window.location.href = cartRoot() + "cart";
      } catch (err) {
        showError(err.message || "Could not add to bag.");
        if (btn) btn.disabled = false;
      }
    });
  })();

  // Shipping protection toggle (service product — no shipping required, ships to Spain)
  const PROTECT_VARIANT_ID = 58706029674880;
  const LEGACY_PROTECT_IDS = new Set([58703491694976]); // archived ES-only duplicate
  const cartRoot = () =>
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const cartJson = async () => {
    const res = await fetch(cartRoot() + "cart.js", { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error("cart.js failed");
    return res.json();
  };
  const changeLine = async (idOrKey, quantity) => {
    const res = await fetch(cartRoot() + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: idOrKey, quantity }),
    });
    if (!res.ok) throw new Error("cart/change failed");
    return res.json();
  };

  // Remove archived duplicate protect SKU if present.
  (async () => {
    try {
      const cart = await cartJson();
      const stale = (cart.items || []).filter((item) =>
        LEGACY_PROTECT_IDS.has(Number(item.variant_id))
      );
      if (!stale.length) return;
      for (const item of stale) await changeLine(item.key, 0);
      window.location.reload();
    } catch (_) {}
  })();

  const protectRoot = $("[data-ship-protect]");
  const protectToggle = $("[data-ship-protect-toggle]");
  if (protectRoot && protectToggle) {
    const subEl = $("[data-ship-protect-sub]", protectRoot);
    const variantId =
      Number(protectRoot.getAttribute("data-variant-id")) || PROTECT_VARIANT_ID;
    const onCopy =
      protectRoot.getAttribute("data-copy-on") ||
      "Extra care is added for this delivery";
    const offCopy =
      protectRoot.getAttribute("data-copy-off") ||
      "Add extra care for this delivery";

    const setBusy = (busy) => {
      protectRoot.classList.toggle("is-busy", busy);
      protectToggle.disabled = busy;
    };
    const syncUi = (on) => {
      protectRoot.classList.toggle("is-on", on);
      protectToggle.checked = on;
      if (subEl) subEl.textContent = on ? onCopy : offCopy;
    };

    protectToggle.addEventListener("change", async () => {
      const wantOn = protectToggle.checked;
      const lineKey = protectRoot.getAttribute("data-line-key") || "";
      setBusy(true);
      try {
        if (wantOn) {
          const res = await fetch(cartRoot() + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }],
            }),
          });
          if (!res.ok) throw new Error("add failed");
        } else {
          const cart = await cartJson();
          const line = (cart.items || []).find(
            (item) => Number(item.variant_id) === variantId
          );
          const res = await fetch(cartRoot() + "cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({
              id: (line && line.key) || lineKey || variantId,
              quantity: 0,
            }),
          });
          if (!res.ok) throw new Error("remove failed");
        }
        syncUi(wantOn);
        window.location.reload();
      } catch (_) {
        syncUi(!wantOn);
        setBusy(false);
      }
    });
  }

  // Homepage: dedupe product cards AND hide product images already used in category tiles / hero
  if (document.body.classList.contains("template-index")) {
    const stem = (u) => {
      try {
        const f = (u || "").split("/").pop().split("?")[0];
        return f.replace(/_\d+x[\w.]*/g, "").replace(/@[0-9]x/g, "").replace(/\.(jpg|jpeg|png|webp).*/i, "").toLowerCase();
      } catch (_) {
        return "";
      }
    };
    const used = new Set();
    $$(".hero-media img, .category-tile__media img").forEach((img) => {
      const s = stem(img.currentSrc || img.src);
      if (s) used.add(s);
    });
    $$(".product-carousel .product-card__link").forEach((link) => {
      const key = (link.getAttribute("href") || "").split("?")[0];
      const img = link.querySelector("img");
      const s = img ? stem(img.currentSrc || img.src) : "";
      const slide = link.closest(".product-carousel__slide");
      if (!slide) return;
      if ((key && used.has("href:" + key)) || (s && used.has(s))) {
        slide.remove();
        return;
      }
      if (key) used.add("href:" + key);
      if (s) used.add(s);
    });
  }

  // Track your order — tabs + carrier / account lookup
  $$("[data-track-order]").forEach((root) => {
    const tabs = $$("[data-track-tab]", root);
    const panels = $$("[data-track-panel]", root);

    function showTab(name) {
      tabs.forEach((tab) => {
        const on = tab.getAttribute("data-track-tab") === name;
        tab.classList.toggle("is-active", on);
        tab.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach((panel) => {
        const on = panel.getAttribute("data-track-panel") === name;
        panel.classList.toggle("is-active", on);
        panel.hidden = !on;
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => showTab(tab.getAttribute("data-track-tab")));
    });

    function detectCarrier(code) {
      const t = code.replace(/\s+/g, "").toUpperCase();
      if (/^1Z[0-9A-Z]{16}$/i.test(t)) {
        return { name: "UPS", url: "https://www.ups.com/track?tracknum=" + encodeURIComponent(t) };
      }
      if (/^\d{12}$|^\d{15}$|^\d{20}$|^\d{22}$/.test(t) && t.length >= 12) {
        // FedEx often 12/15/20/22 digits — also try 17track as fallback via chooser
        return { name: "FedEx", url: "https://www.fedex.com/fedextrack/?trknbr=" + encodeURIComponent(t) };
      }
      if (/^\d{10,11}$/.test(t) || /^JD\d+/i.test(t) || /^[0-9]{10}GB$/i.test(t)) {
        return { name: "DHL", url: "https://www.dhl.com/global-en/home/tracking/tracking-express.html?submit=1&tracking-id=" + encodeURIComponent(t) };
      }
      if (/^(9[0-9]{21}|9[0-9]{15}|[A-Z]{2}\d{9}US)$/i.test(t)) {
        return { name: "USPS", url: "https://tools.usps.com/go/TrackConfirmAction?tLabels=" + encodeURIComponent(t) };
      }
      if (/^[A-Z]{2}\d{9}GB$/i.test(t) || /^[A-Z]{2}\d{9}[A-Z]{2}$/i.test(t)) {
        return { name: "Royal Mail", url: "https://www.royalmail.com/track-your-item#/tracking-results/" + encodeURIComponent(t) };
      }
      if (/^H[A-Z0-9]{15}$/i.test(t) || /^T[A-Z0-9]{10,}$/i.test(t)) {
        return { name: "Evri", url: "https://www.evri.com/track/parcel/" + encodeURIComponent(t) + "/details" };
      }
      if (/^[A-Z]{2}\d{9}FR$/i.test(t) || /^6A\d+/i.test(t) || /^[A-Z]{1}\d{10}$/i.test(t)) {
        return { name: "Colissimo / La Poste", url: "https://www.laposte.fr/outils/suivre-vos-envois?code=" + encodeURIComponent(t) };
      }
      // Universal multi-carrier tracker (professional fallback for Yanwen, 4PX, Cainiao, etc.)
      return {
        name: "17TRACK",
        url: "https://www.17track.net/en/track?nums=" + encodeURIComponent(t)
      };
    }

    const numberForm = root.querySelector('[data-track-form="number"]');
    if (numberForm) {
      numberForm.addEventListener("submit", (e) => {
        e.preventDefault();
        const input = numberForm.querySelector("[data-track-input]");
        const err = numberForm.querySelector("[data-track-error]");
        const raw = (input?.value || "").trim();
        if (raw.length < 6) {
          if (err) {
            err.hidden = false;
            err.textContent = "Enter a valid tracking number (at least 6 characters).";
          }
          return;
        }
        if (err) err.hidden = true;
        const carrier = detectCarrier(raw);
        window.open(carrier.url, "_blank", "noopener,noreferrer");
      });
    }

    const orderForm = root.querySelector('[data-track-form="order"]');
    if (orderForm) {
      orderForm.addEventListener("submit", (e) => {
        e.preventDefault();
        const orderInput = orderForm.querySelector("[data-order-number]");
        const emailInput = orderForm.querySelector("[data-order-email]");
        const err = orderForm.querySelector("[data-order-error]");
        const orderNo = (orderInput?.value || "").trim();
        const email = (emailInput?.value || "").trim();
        if (!orderNo || !email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          if (err) {
            err.hidden = false;
            err.textContent = "Enter your order number and the email used at checkout.";
          }
          return;
        }
        if (err) err.hidden = true;
        try {
          sessionStorage.setItem(
            "savintari_track_lookup",
            JSON.stringify({ order: orderNo, email: email, at: Date.now() })
          );
        } catch (_) {}
        const accountLogin = root.getAttribute("data-account-login") || "/account/login";
        const accountOrders = root.getAttribute("data-account-orders") || "/account";
        const sep = accountLogin.indexOf("?") >= 0 ? "&" : "?";
        window.location.href =
          accountLogin + sep + "return_url=" + encodeURIComponent(accountOrders);
      });
    }
  });

  $$("[data-sv-proof]").forEach((root) => {
    const facesWrap = root.querySelector("[data-sv-faces]");
    const countEl = root.querySelector("[data-sv-order-count]");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const pool = [0, 1, 2, 3, 4, 5, 6, 7];
    const faceHtml = (seed) => {
      const tpl = document.querySelector('[data-sv-face="' + seed + '"]');
      return tpl ? tpl.innerHTML : "";
    };

    if (facesWrap && !reduceMotion) {
      const slots = $$("[data-face]", facesWrap);
      let used = slots.map((s) => Number(s.getAttribute("data-face")));
      setInterval(() => {
        const slot = slots[Math.floor(Math.random() * slots.length)];
        if (!slot) return;
        const current = Number(slot.getAttribute("data-face"));
        const free = pool.filter((n) => used.indexOf(n) === -1);
        if (!free.length) return;
        const next = free[Math.floor(Math.random() * free.length)];
        const html = faceHtml(next);
        if (!html) return;
        slot.classList.add("is-swapping");
        window.setTimeout(() => {
          slot.innerHTML = html + "<b>✓</b>";
          slot.setAttribute("data-face", String(next));
          used = slots.map((s) => Number(s.getAttribute("data-face")));
          slot.classList.remove("is-swapping");
        }, 220);
      }, 2800);
    }

    if (countEl) {
      const dayKey = "sv_proof_orders_" + new Date().toISOString().slice(0, 10);
      const base = Math.max(1, parseInt(root.getAttribute("data-orders-base") || "186", 10) || 186);
      let n = base;
      try {
        const saved = parseInt(sessionStorage.getItem(dayKey) || "", 10);
        if (saved >= base) n = saved;
      } catch (_) {}
      const paint = () => {
        countEl.textContent = n + "+ orders";
      };
      paint();
      if (!reduceMotion) {
        const tick = () => {
          n += 1;
          try {
            sessionStorage.setItem(dayKey, String(n));
          } catch (_) {}
          countEl.classList.add("is-bumping");
          paint();
          window.setTimeout(() => countEl.classList.remove("is-bumping"), 420);
          window.setTimeout(tick, 4500 + Math.floor(Math.random() * 4000));
        };
        window.setTimeout(tick, 3200);
      }
    }
  });

  const styleFilter = $("[data-style-filter]");
  if (styleFilter) {
    const cards = $$("[data-card-style]");
    const buttons = $$("[data-style]", styleFilter);
    const empty = $("[data-style-empty]");
    buttons.forEach((btn) => {
      const style = btn.getAttribute("data-style");
      if (style === "all") return;
      const n = cards.filter((c) => c.getAttribute("data-card-style") === style).length;
      if (!n) btn.hidden = true;
    });
    styleFilter.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-style]");
      if (!btn) return;
      const style = btn.getAttribute("data-style");
      buttons.forEach((b) => b.classList.toggle("is-active", b === btn));
      let shown = 0;
      cards.forEach((card) => {
        const match = style === "all" || card.getAttribute("data-card-style") === style;
        card.classList.toggle("is-hidden-style", !match);
        if (match) shown += 1;
      });
      if (empty) empty.hidden = shown > 0;
    });
  }
})();
